const BaseComponent = require('base/base-component');

const colorArray = ['#B1DC97', '#B7DCF6', '#FFE0E1', '#FFCF76', '#D3D2D3', '#FFF09C'];

const filteredProvinces = [
  '石河子市',
  '阿拉尔市',
  '图木舒克市',
  '五家渠市',
  '北屯市',
  '铁门关市',
  '双河市',
  '可克达拉市',
  '昆玉市'
];

class mapNav extends BaseComponent {
  init () {
    const district = this.$el.find('[name=map-district]').val() || 'china';
    const borderColor = this.$el.find('[name=map-border-color]').val() || '#FF6300';
    const geochina = 'https://data.jianshukeji.com/jsonp?filename=geochina/';
    $.getJSON(geochina + district + '.json&callback=?', (mapdata) => {
      const data = [];
      // 随机数据
      Highcharts.each(mapdata.features, (md, index) => {
        const tmp = {
          name: md.properties.name,
          color: colorArray[index % colorArray.length]
        };
        if (filteredProvinces.indexOf(md.properties.fullname) === -1) {
          data.push(tmp);
        }
      });
      new Highcharts.Map('map-container', {
        title: null,
        subtitle: null,
        legend: false,
        chart: {
          backgroundColor: 'transparent'
        },
        tooltip: {
          useHTML: true,
          headerFormat: '<table><tr><td>{point.name}</td></tr>',
          pointFormat:
            '<tr><td>全称</td><td>{point.properties.fullname}</td></tr>' +
            '<tr><td>行政编号</td><td>{point.properties.areacode}</td></tr>' +
            '<tr><td>父级</td><td>{point.properties.parent}</td></tr>' +
            '<tr><td>经纬度</td><td>{point.properties.longitude},{point.properties.latitude}</td></tr>',
          footerFormat: '</table>'
        },
        series: [
          {
            data,
            mapData: mapdata,
            joinBy: 'name',
            dataLabels: {
              // https://api.hcharts.cn/highcharts#series%3Carea%3E.dataLabels.allowOverlap
              allowOverlap: true,
              enabled: true,
              formatter () {
                return this.point.properties.name;
              },
              style: {
                fontSize: '12px',
                color: '#333333'
              },
              x: 10
            },
            borderColor,
            borderWidth: 0.4,
            states: {
              hover: {
                color: '#a4edba'
              }
            }
          }
        ]
      });
    });
  }
}
module.exports = mapNav;
